import { JourneyUiDefinition } from '../models/onboarding.types';
import { ACCOUNT_REVALIDATION_TRIGGERS } from './account-triggers';

const BASE = 'onboarding.journeys.shipper_first_spot';
const STEPS = `${BASE}.steps`;

/**
 * Jornada "Embarcador · Primeira Oferta Spot" (chave do backend: shipper-first-spot). Só textos,
 * rotas, tutoriais e gatilhos: a regra de cada etapa mora nos validadores do backend.
 */
export const SHIPPER_FIRST_SPOT_JOURNEY: JourneyUiDefinition = {
  journeyKey: 'shipper-first-spot',
  titleKey: `${BASE}.title`,
  subtitleKey: `${BASE}.subtitle`,
  welcome: {
    titleKey: `${BASE}.welcome.title`,
    leadKey: `${BASE}.welcome.lead`,
    leadReadyKey: `${BASE}.welcome.lead_ready`,
    benefitKeys: [`${BASE}.welcome.benefit_real`, `${BASE}.welcome.benefit_pause`, `${BASE}.welcome.benefit_ready`],
  },
  completion: {
    titleKey: `${BASE}.completion.title`,
    messageKey: `${BASE}.completion.message`,
    actions: [
      { id: 'onboarding-completion-offers-link', labelKey: `${BASE}.completion.track_offers`, route: '/app/shipper/offers' },
      { id: 'onboarding-completion-new-spot-link', labelKey: `${BASE}.completion.new_spot`, route: '/app/shipper/offers/spot' },
    ],
  },
  steps: {
    company: {
      titleKey: `${STEPS}.company.title`,
      descriptionKey: `${STEPS}.company.description`,
      whyKey: `${STEPS}.company.why`,
      icon: 'domain',
      route: '/app/configurations-shipper/companies',
      actionLabelKey: `${STEPS}.company.action`,
      tutorialKey: 'create-company',
      statusMessageKeys: { AVAILABLE: `${STEPS}.company.available`, IN_PROGRESS: `${STEPS}.company.available` },
      readyMessageKey: `${STEPS}.company.ready`,
      evidenceLines: [{ evidence: 'empresas', labelKey: `${STEPS}.company.evidence_companies`, hideWhenZero: true }],
    },
    team: {
      titleKey: `${STEPS}.team.title`,
      descriptionKey: `${STEPS}.team.description`,
      whyKey: `${STEPS}.team.why`,
      icon: 'group_add',
      route: '/app/configurations-shipper/users',
      actionLabelKey: `${STEPS}.team.action`,
      tutorialKey: 'link-user-companies',
      statusMessageKeys: { BLOCKED: `${STEPS}.team.blocked` },
      readyMessageKey: `${STEPS}.team.ready`,
      evidenceLines: [{ evidence: 'usuarios', labelKey: `${STEPS}.team.evidence_users`, hideWhenZero: true }],
    },
    recipients: {
      titleKey: `${STEPS}.recipients.title`,
      descriptionKey: `${STEPS}.recipients.description`,
      whyKey: `${STEPS}.recipients.why`,
      icon: 'person_pin_circle',
      route: '/app/configurations-shipper/recipients',
      actionLabelKey: `${STEPS}.recipients.action`,
      tutorialKey: 'create-recipient',
      readyMessageKey: `${STEPS}.recipients.ready`,
      evidenceLines: [
        { evidence: 'destinatarios', labelKey: `${STEPS}.recipients.evidence_recipients`, hideWhenZero: true },
      ],
    },
    carriers: {
      titleKey: `${STEPS}.carriers.title`,
      descriptionKey: `${STEPS}.carriers.description`,
      whyKey: `${STEPS}.carriers.why`,
      icon: 'local_shipping',
      route: '/app/shipper/explore-carriers',
      actionLabelKey: `${STEPS}.carriers.action`,
      tutorialKey: 'invite-carrier',
      statusMessageKeys: {
        AVAILABLE: `${STEPS}.carriers.available`,
        WAITING_EXTERNAL: `${STEPS}.carriers.waiting`,
        BLOCKED: `${STEPS}.carriers.blocked`,
        COMPLETED: `${STEPS}.carriers.completed`,
      },
      readyMessageKey: `${STEPS}.carriers.ready`,
      evidenceLines: [
        { evidence: 'parceiras', labelKey: `${STEPS}.carriers.evidence_partners`, hideWhenZero: true },
        { evidence: 'aguardandoCadastro', labelKey: `${STEPS}.carriers.evidence_waiting_registration`, hideWhenZero: true },
        { evidence: 'aguardandoAceite', labelKey: `${STEPS}.carriers.evidence_waiting_acceptance`, hideWhenZero: true },
        { evidence: 'semResposta', labelKey: `${STEPS}.carriers.evidence_no_answer`, hideWhenZero: true, tone: 'warning' },
        { evidence: 'recusados', labelKey: `${STEPS}.carriers.evidence_refused`, hideWhenZero: true },
        { evidence: 'parceirasComPerfilIncompleto', labelKey: `${STEPS}.carriers.evidence_incomplete_profile`, hideWhenZero: true, tone: 'warning' },
      ],
    },
    first_spot: {
      titleKey: `${STEPS}.first_spot.title`,
      descriptionKey: `${STEPS}.first_spot.description`,
      whyKey: `${STEPS}.first_spot.why`,
      icon: 'rocket_launch',
      route: '/app/shipper/offers/spot',
      actionLabelKey: `${STEPS}.first_spot.action`,
      tutorialKey: 'create-spot-offer',
      statusMessageKeys: { BLOCKED: `${STEPS}.first_spot.blocked`, AVAILABLE: `${STEPS}.first_spot.available` },
      evidenceLines: [
        { evidence: 'parceirasComPerfilIncompleto', labelKey: `${STEPS}.first_spot.evidence_incomplete_profile`, hideWhenZero: true, tone: 'warning' },
      ],
    },
  },
  revalidateOn: [
    ...ACCOUNT_REVALIDATION_TRIGGERS,
    { method: 'POST', urlPattern: String.raw`/leilao/destinatario(/|\?|$)` },
    { method: 'DELETE', urlPattern: String.raw`/leilao/destinatario(/|\?|$)` },
    { method: 'POST', urlPattern: '/leilao/convite/' },
    { method: 'PUT', urlPattern: '/leilao/convite/' },
    { method: 'DELETE', urlPattern: '/leilao/convite' },
    { method: 'DELETE', urlPattern: '/leilao/parceria/' },
    { method: 'POST', urlPattern: String.raw`/leilao/oferta(\?|$)` },
    { method: 'POST', urlPattern: String.raw`/leilao/oferta/rascunho/\d+/publicar` },
  ],
};
